export { default as DashboardPageContent } from './DashboardPageContent';
